import { render, staticRenderFns } from "./InsightsTopSlot.vue?vue&type=template&id=6f3a73b1"
import script from "./InsightsTopSlot.vue?vue&type=script&lang=js"
export * from "./InsightsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports